export enum StatusFilter {
  All = 'All',
  Active = 'Active',
  Completed = 'Completed',
}
